// extracted by mini-css-extract-plugin
export default {"border_color":"style_border_color__3xSgu","cursor_pointer":"style_cursor_pointer__OY9eb","scrollbar_custom":"style_scrollbar_custom__r9fCf"};